import { Button, Card, Drawer, Dropdown, Typography } from "antd";

import { useState } from "react";
import { Link } from "react-router-dom";
import { keycloak } from "../../..";
import { useAppSelector } from "../../../app/store";
import {
  useGetAllProductQuery,
  useGetProjectsByUserQuery,
  useLazyCheckUserBelongProjectQuery,
} from "../../../features/portal/Products/productsApi";
import {
  useGetAllAssignProjectQuery,
  useGetSingleCompanyQuery,
} from "../../../features/portal/companyOnboard/companyOnboardApi";
import { useGetDashboardDataQuery } from "../../../features/portal/user/userApi";
import useError from "../../../hooks/useError";
import useModal from "../../../hooks/useModal";
import { toast } from "../../../lib/toast";
import { createHash } from "../../../utils/hash";
import {
  buildProductLaunchUrl,
  resolveLocalDigigoRedirectUri,
} from "../../../utils/redirectUri";

type KeywordType = {
  projectId: number;
  dynamicId: any;
  dynamicKeyword: any;
};

export default function ProductsMenu() {
  const Statistic = ({
    title,
    value,
    icon: Icon,
    bgColor,
    iconColor,
  }: {
    title: string;
    value: string | number;
    icon: (props: { iconColor?: string }) => JSX.Element;
    bgColor: string;
    iconColor: string;
  }) => {
    return (
      <div className="flex gap-2 items-center bg-white">
        <div
          className="h-full flex items-center p-2"
          style={{ background: bgColor }}
        >
          <Icon iconColor={iconColor} />
        </div>
        <div className="p-2">
          <div className="font-bold text-[36px]">{value}</div>
          <div className="text-[#8897AE]">{title}</div>
        </div>
      </div>
    );
  };

  const { Text } = Typography;
  const [selectedSupplierId, setSelectedSupplierId] = useState<number | null>(
    null
  );

  const [blockedProjectId, setBlockedProjectId] = useState<number | null>(null);
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const {
    open: openDynamicModal,
    handleOpen: handleDynamicOpen,
    handleClose: handleDynamicClose,
  } = useModal<undefined, "CONFIRM">();

  const [modalActionData, setModalActionData] = useState<{
    redirectUri: string;
    logo?: string;
    payload?: any;
    redirectToAnotherWebsite?: boolean;
  } | null>(null);
  const [open, setOpen] = useState(false);

  const { user, role } = useAppSelector((state) => state.auth);
  const { isError, error, isLoading, data } = useGetProjectsByUserQuery({
    params: {
      userid: user?.data?.id,
    },
  });
  const {
    isError: isCompanyError,
    error: companyError,
    isLoading: isCompanyLoading,
    data: companyData,
  } = useGetSingleCompanyQuery(user?.data?.company_id || "", {
    skip: !user?.data?.company_id,
  });

  const {
    isLoading: isAllProductLoading,
    isError: isAllProductError,
    error: allProductError,
    data: getAllProduct,
  } = useGetAllProductQuery({
    params: {
      status: true,
      limit: 100000,
      isDraft: "true",
    },
  });

  const {
    isLoading: getDashboardDataIsLoading,
    isError: getDashboardDataIsError,
    error: getDashboardDataError,
    data: getDashboardData,
  } = useGetDashboardDataQuery({
    params: {
      company_id: role === "SUPER_ADMIN" ? undefined : user?.data?.company_id,
    },
  });

  const companyId = user?.data?.company_id
    ? Number(user?.data?.company_id)
    : undefined;

  const {
    isError: getAllAssignProjectIsError,
    error: getAllAssignProjectError,
    isLoading: getAllAssignProjectIsLoading,
    data: getAllAssignProject,
  } = useGetAllAssignProjectQuery(
    { id: companyId as number, search: undefined },
    {
      skip: !companyId, // only run when companyId exists
    }
  );

  const [triggerCheckUserBelongProject] = useLazyCheckUserBelongProjectQuery();

  useError(isAllProductError, allProductError, "Get all product fail");
  useError(isError, error, "User get fail");
  // useError(isCompanyError, companyError, "Company get fail");
  useError(
    getDashboardDataIsError,
    getDashboardDataError,
    "Dashboard data get fail"
  );

  // console.log(companyData?.data?.dynamicId, companyData?.data?.dyncamicKeyword);

  // const handleSelectSupplier = () => {
  //   if (!modalActionData) return;

  //   const { redirectUri, logo, payload, redirectToAnotherWebsite } =
  //     modalActionData;

  //   // Call the original functions now
  //   if (redirectToAnotherWebsite) {
  //     handleRedirect(redirectUri, payload);
  //   } else {
  //     handleProject(redirectUri, logo, payload);
  //   }

  //   handleDynamicClose();
  // };

  // const selectedSupplier = companyData?.data?.dynamicKeys?.find(
  //   (item: any) => item.id === selectedSupplierId
  // );

  const selectedSupplier = companyData?.data?.dynamicKeys?.[0];

  const handleProject = (
    // role: string,
    redirectUri: string,
    projectLogo: any,
    { projectId }: KeywordType
  ) => {
    const finalRedirectUri = resolveLocalDigigoRedirectUri(redirectUri);
    const matchedRole = data?.data?.find(
      (item: any) => item?.project?.id === projectId
    );

    const roleName = matchedRole?.role?.roleName;
    const projectName = matchedRole?.project?.name;

    // ✅ Set roleName to localStorage
    if (roleName) {
      localStorage.setItem("project_role", roleName);
    }

    if (projectName) {
      localStorage.setItem("product_name", projectName);
    }

    // localStorage.setItem("project_role", role);
    localStorage.setItem("product_id", String(projectId));
    localStorage.setItem("product_logo", String(projectLogo));
    const dynamicId = companyData?.data?.dynamicId;
    const dynamicKeyword = companyData?.data?.dyncamicKeyword;
    // const dynamicId = selectedSupplier?.dynamic_id;
    // const dynamicKeyword = selectedSupplier?.dynamic_keyword;

    // if (!dynamicId || !dynamicKeyword) {
    //   toast("error", "Please set dynamic id and dynamic keyword");
    //   return;
    // }

    // console.log("projectId Check", projectId);

    const pId = projectId ? createHash(String(projectId)) : "";
    const dId = dynamicId ? createHash(String(dynamicId)) : "";
    const dText = dynamicKeyword ? createHash(String(dynamicKeyword)) : "";

    const url = buildProductLaunchUrl(finalRedirectUri, {
      projectType: pId,
      dynamicId: dId,
      dynamicKeyword: dText,
      token: keycloak?.token,
    });

    const bsrm_url = "/admin/bsrm/dashboard";

    const cash_collection_url = "/admin/cash-dashboard";

    if (finalRedirectUri?.includes(bsrm_url)) {
      localStorage.setItem("BSRM_USER", "BSRM_USER");
    }

    if (finalRedirectUri?.includes(cash_collection_url)) {
      localStorage.setItem("BSRM_USER", "CASH_USER");
    }

    if (finalRedirectUri) window.location.assign(url);
    // navigate("/admin/salary-disbursement/batch");
  };

  const handleRedirect = (
    // role: string,
    redirectUri: string,
    { projectId, dynamicId, dynamicKeyword }: KeywordType
  ) => {
    const finalRedirectUri = resolveLocalDigigoRedirectUri(redirectUri);
    // localStorage.setItem("project_role", role);
    if (finalRedirectUri) {
      const pId = projectId ? createHash(String(projectId)) : "";
      const dId = dynamicId ? createHash(String(dynamicId)) : "";
      const dText = dynamicKeyword ? createHash(String(dynamicKeyword)) : "";

      const url = buildProductLaunchUrl(finalRedirectUri, {
        projectType: pId,
        dynamicId: dId,
        dynamicKeyword: dText,
        token: keycloak?.token,
      });

      // console.log(url);

      window.open(url, "_blank", "noopener,noreferrer");
    }
  };

  const showDrawer = () => {
    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
    setBlockedProjectId(null);
  };

  const filteredProject = getAllProduct?.data?.data?.find(
    (item: any) => item.id === blockedProjectId
  );

  return (
    <>
      <Dropdown
        trigger={["click"]}
        placement="bottomRight"
        arrow={{ pointAtCenter: true }}
        className="cursor-pointer"
        rootClassName="!left-auto !right-5"
        open={dropdownOpen} // control the open state
        onOpenChange={(open) => setDropdownOpen(open)}
        dropdownRender={() => (
          <>
            {companyData?.data?.can_view_all_products === true ? (
              <>
                {role === "SUPER_ADMIN" ? (
                  <Card className="!h-[450px] overflow-y-auto">
                    <div className="grid grid-cols-3 gap-4">
                      {getAllProduct?.data?.data.map((val, index) => {
                        // const redirectUri = val?.redirectUri?.trim();

                        return (
                          <div key={index}>
                            <div
                              className="    
    group
    w-28        
    p-2 rounded-md flex flex-col items-center justify-start gap-2 mb-0
    transition-[max-height] duration-300 ease-in-out
    border border-transparent
    hover:border-[#F05323] hover:bg-[#FEEEE9]"
                            >
                              <div className="flex items-center justify-center">
                                <img
                                  className="h-[34px] w-[34px] object-contain"
                                  src={val?.logo}
                                  alt="project_logo"
                                />
                              </div>

                              <div
                                className="
      text-center text-zinc-700 text-sm leading-tight
      w-full                              
    "
                              >
                                {val?.name}
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </Card>
                ) : (
                  <Card className="!h-[450px] overflow-y-auto">
                    <div className="grid grid-cols-3 gap-4">
                      {getAllProduct?.data?.data.map((val, index) => {
                        return (
                          <div
                            key={index}
                            onClick={() => {
                              if (!val?.redirectUri?.trim()) return;

                              triggerCheckUserBelongProject({
                                params: { projectId: val?.id },
                              })
                                .unwrap()
                                .then((response) => {
                                  const exists = response?.data?.exists;

                                  if (!exists) {
                                    // toast(
                                    //   "warning",
                                    //   "To access this feature, please purchase a subscription plan or contact Sheba Admin"
                                    // );
                                    setBlockedProjectId(val?.id);
                                    showDrawer();
                                    setDropdownOpen(false);
                                    return;
                                  }

                                  // Prepare payload based on is_dynamic_key
                                  const payload = {
                                    projectId: val.id,
                                    dynamicId: val.is_dynamic_key
                                      ? selectedSupplier?.dynamic_id
                                      : val?.dynamicId,
                                    dynamicKeyword: val.is_dynamic_key
                                      ? selectedSupplier?.dynamic_keyword
                                      : val?.dyncamicKeyword,
                                  };

                                  if (val.is_dynamic_key) {
                                    // 🔹 Instead of opening modal → call functions directly
                                    if (val.redirectToAnotherWebsite) {
                                      handleRedirect(
                                        val.redirectUri.trim(),
                                        payload
                                      );
                                    } else {
                                      handleProject(
                                        val.redirectUri.trim(),
                                        val.logo,
                                        payload
                                      );
                                    }
                                  } else {
                                    // If is_dynamic_key === false
                                    if (val.redirectToAnotherWebsite) {
                                      handleRedirect(
                                        val.redirectUri.trim(),
                                        payload
                                      );
                                    } else {
                                      handleProject(
                                        val.redirectUri.trim(),
                                        val.logo,
                                        payload
                                      );
                                    }
                                  }
                                })
                                .catch(() =>
                                  toast("error", "Something went wrong")
                                );
                            }}
                          >
                            <div
                              className="    
    group
    w-28        
    p-2 rounded-md flex flex-col items-center justify-start gap-2 mb-0
    transition-[max-height] duration-300 ease-in-out
    border border-transparent
    hover:border-[#F05323] hover:bg-[#FEEEE9]"
                            >
                              <div className="flex items-center justify-center">
                                <img
                                  className="h-[34px] w-[34px] object-contain"
                                  src={val?.logo}
                                  alt="project_logo"
                                />
                              </div>

                              <div
                                className="
      text-center text-zinc-700 text-sm leading-tight
      w-full                              
    "
                              >
                                {val?.name}
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </Card>
                )}
              </>
            ) : (
              <>
                {role === "SUPER_ADMIN" ? (
                  <Card className="!h-[450px] overflow-y-auto">
                    <div className="grid grid-cols-3 gap-4">
                      {getAllAssignProject?.data?.projects.map((val, index) => {
                        // const redirectUri = val?.redirectUri?.trim();

                        return (
                          <div key={index}>
                            <div
                              className="    
    group
    w-28        
    p-2 rounded-md flex flex-col items-center justify-start gap-2 mb-0
    transition-[max-height] duration-300 ease-in-out
    border border-transparent
    hover:border-[#F05323] hover:bg-[#FEEEE9]"
                            >
                              <div className="flex items-center justify-center">
                                <img
                                  className="h-[34px] w-[34px] object-contain"
                                  src={val?.project_logo}
                                  alt="project_logo"
                                />
                              </div>

                              <div
                                className="
      text-center text-zinc-700 text-sm leading-tight
      w-full                              
    "
                              >
                                {val?.project_name}
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </Card>
                ) : (
                  <Card className="!h-[450px] overflow-y-auto">
                    <div className="grid grid-cols-3 gap-4">
                      {getAllAssignProject?.data?.projects.map((val, index) => {
                        return (
                          <div
                            key={index}
                            onClick={() => {
                              if (!val?.redirectUri?.trim()) return;

                              triggerCheckUserBelongProject({
                                params: { projectId: val?.project_id },
                              })
                                .unwrap()
                                .then((response) => {
                                  const exists = response?.data?.exists;

                                  if (!exists) {
                                    // toast(
                                    //   "warning",
                                    //   "To access this feature, please purchase a subscription plan or contact Sheba Admin"
                                    // );
                                    setBlockedProjectId(val?.project_id);
                                    showDrawer();
                                    setDropdownOpen(false);
                                    return;
                                  }

                                  // Prepare payload based on is_dynamic_key
                                  const payload = {
                                    projectId: val.project_id,
                                    dynamicId: val.is_dynamic_key
                                      ? selectedSupplier?.dynamic_id
                                      : val?.dynamicId,
                                    dynamicKeyword: val.is_dynamic_key
                                      ? selectedSupplier?.dynamic_keyword
                                      : val?.dyncamicKeyword,
                                  };

                                  if (val.is_dynamic_key) {
                                    // 🔹 Instead of opening modal → call functions directly
                                    if (val.redirectToAnotherWebsite) {
                                      handleRedirect(
                                        val.redirectUri.trim(),
                                        payload
                                      );
                                    } else {
                                      handleProject(
                                        val.redirectUri.trim(),
                                        val.project_logo,
                                        payload
                                      );
                                    }
                                  } else {
                                    // If is_dynamic_key === false
                                    if (val.redirectToAnotherWebsite) {
                                      handleRedirect(
                                        val.redirectUri.trim(),
                                        payload
                                      );
                                    } else {
                                      handleProject(
                                        val.redirectUri.trim(),
                                        val.project_logo,
                                        payload
                                      );
                                    }
                                  }
                                })
                                .catch(() =>
                                  toast("error", "Something went wrong")
                                );
                            }}
                          >
                            <div
                              className="    
    group
    w-28        
    p-2 rounded-md flex flex-col items-center justify-start gap-2 mb-0
    transition-[max-height] duration-300 ease-in-out
    border border-transparent
    hover:border-[#F05323] hover:bg-[#FEEEE9]"
                            >
                              <div className="flex items-center justify-center">
                                <img
                                  className="h-[34px] w-[34px] object-contain"
                                  src={val?.project_logo}
                                  alt="project_logo"
                                />
                              </div>

                              <div
                                className="
      text-center text-zinc-700 text-sm leading-tight
      w-full                              
    "
                              >
                                {val?.project_name}
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </Card>
                )}
              </>
            )}
          </>
        )}
      >
        <div className="flex items-center gap-2.5 cursor-pointer">
          <MenuIcon />
          {/* <span className="text-[#555b6d] text-base font-medium flex items-center">
          {login?.firstName} <BottomDropdownIcon />
        </span> */}
        </div>
      </Dropdown>

      <Drawer open={open} width={500} onClose={onClose}>
        <div className="flex items-center justify-start gap-2">
          <div className="w-14 h-14 flex items-center justify-center">
            <img
              className="w-14 h-14 object-contain"
              src={filteredProject?.logo}
              alt="project_logo"
            />
          </div>

          <div className="text-[#1f285d] font-bold text-2xl">
            {filteredProject?.name}
          </div>
        </div>

        <div>
          {filteredProject?.projectFeatures?.map((item) => (
            <div className="mt-10 mb-5" key={item?.id}>
              {item?.feature_image && (
                <>
                  <div className="w-full h-full mb-8">
                    <img src={item?.feature_image} alt="feature_image" />
                  </div>
                </>
              )}

              {item?.details && (
                <>
                  <div
                    className="prose max-w-none product-dowar"
                    dangerouslySetInnerHTML={{ __html: item.details }}
                  />
                </>
              )}

              {item?.button && (
                <Link to={item?.button_link}>
                  <Button
                    type="primary"
                    size="middle"
                    className="mt-5 px-3.5 py-2 !bg-pink-700 !hover:bg-pink-800 inline-flex justify-center items-center text-white text-sm font-semibold gap-2.5 !rounded-[100px]"
                  >
                    {item?.button}
                  </Button>
                </Link>
              )}
            </div>
          ))}
        </div>
      </Drawer>
    </>
  );
}

function MenuIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M1.5 3C1.5 2.17157 2.17157 1.5 3 1.5H6C6.82843 1.5 7.5 2.17157 7.5 3V6C7.5 6.82843 6.82843 7.5 6 7.5H3C2.17157 7.5 1.5 6.82843 1.5 6V3Z"
        fill="#AFBACA"
      />
      <path
        d="M9 3C9 2.17157 9.67157 1.5 10.5 1.5H13.5C14.3284 1.5 15 2.17157 15 3V6C15 6.82843 14.3284 7.5 13.5 7.5H10.5C9.67157 7.5 9 6.82843 9 6V3Z"
        fill="#AFBACA"
      />
      <path
        d="M16.5 3C16.5 2.17157 17.1716 1.5 18 1.5H21C21.8284 1.5 22.5 2.17157 22.5 3V6C22.5 6.82843 21.8284 7.5 21 7.5H18C17.1716 7.5 16.5 6.82843 16.5 6V3Z"
        fill="#AFBACA"
      />
      <path
        d="M1.5 10.5C1.5 9.67157 2.17157 9 3 9H6C6.82843 9 7.5 9.67157 7.5 10.5V13.5C7.5 14.3284 6.82843 15 6 15H3C2.17157 15 1.5 14.3284 1.5 13.5V10.5Z"
        fill="#AFBACA"
      />
      <path
        d="M9 10.5C9 9.67157 9.67157 9 10.5 9H13.5C14.3284 9 15 9.67157 15 10.5V13.5C15 14.3284 14.3284 15 13.5 15H10.5C9.67157 15 9 14.3284 9 13.5V10.5Z"
        fill="#AFBACA"
      />
      <path
        d="M16.5 10.5C16.5 9.67157 17.1716 9 18 9H21C21.8284 9 22.5 9.67157 22.5 10.5V13.5C22.5 14.3284 21.8284 15 21 15H18C17.1716 15 16.5 14.3284 16.5 13.5V10.5Z"
        fill="#AFBACA"
      />
      <path
        d="M1.5 18C1.5 17.1716 2.17157 16.5 3 16.5H6C6.82843 16.5 7.5 17.1716 7.5 18V21C7.5 21.8284 6.82843 22.5 6 22.5H3C2.17157 22.5 1.5 21.8284 1.5 21V18Z"
        fill="#AFBACA"
      />
      <path
        d="M9 18C9 17.1716 9.67157 16.5 10.5 16.5H13.5C14.3284 16.5 15 17.1716 15 18V21C15 21.8284 14.3284 22.5 13.5 22.5H10.5C9.67157 22.5 9 21.8284 9 21V18Z"
        fill="#AFBACA"
      />
      <path
        d="M16.5 18C16.5 17.1716 17.1716 16.5 18 16.5H21C21.8284 16.5 22.5 17.1716 22.5 18V21C22.5 21.8284 21.8284 22.5 21 22.5H18C17.1716 22.5 16.5 21.8284 16.5 21V18Z"
        fill="#AFBACA"
      />
    </svg>
  );
}
